var MobileHomepage = function() {

    var hash_recompute = function(view, mid = MobileHomepage.openmatch) {
        if (view) {
            MatchesTable.match_filter = view;
        }
        MobileHomepage.openmatch = mid;
        var hash = MatchesTable.match_filter + (MobileHomepage.openmatch ? ('_' + MobileHomepage.openmatch) : '');
        if (window.history.state &&
            window.history.state.match &&
            !MobileHomepage.openmatch) {
            window.history.back();
        } else if ((!window.history.state || !window.history.state.match) &&
                   MobileHomepage.openmatch) {
            window.history.pushState(
                {view: MatchesTable.match_filter, match: MobileHomepage.openmatch},
                null, '#' + hash);
        } else {
            window.history.replaceState(
                {view: MatchesTable.match_filter, match: MobileHomepage.openmatch},
                null, '#' + hash);
        }
        return hash;
    };

    var parse_hash = function() {
        var parts = window.location.hash.substr(1).split('_');
        if (parts.length > 0 &&
            parts[0] in {'all': 1, 'fav': 1, 'live': 1, 'fin': 1, 'sched': 1}) {
            MatchesTable.match_filter = parts[0];
            MatchesTable.applyAllFilters();
        }
        if (parts.length > 1 && parseInt(parts[1]) > 0) {
            MobileHomepage.openmatch = parts[1];
            MobileHomepage.tr_click(MobileHomepage.openmatch);
        }
    };

    return {
        init: function(date) {
            MobileHomepage.openmatch = false;
            MobileHomepage.date = date;
            MobileHomepage.glomex = false;
            parse_hash();
            $(document).on('click', 'tr.ii__match_row', function(e){
                if ($(this).data('mid')) {
                    e.stopPropagation();
                    e.preventDefault();
                    MobileHomepage.tr_click($(this).data('mid'));
                }
            });
            // filter matches buttons
            $('.ii__mf_btn').click(function() {
                var filter = $(this).data('filter');
                if (filter != undefined) {
                    hash_recompute(filter);
                }
            });
            // order by buttons
            $('.ii__om_btn').click(function() {
                var order = $(this).data('orderby');
                if (order != undefined) {
                    MobileHomepage.order_matches(order);
                }
            });
            $('#save_odds_company').change(function() {
                MobileHomepage.saveOddsCompany($(this).val());
            });
            MobileGeneric.initAnalysiTabTrigger();
            if (Generic.getParam('_update_method') != 'push') {
                setTimeout(MobileHomepage.matchesRefreshLoop, 20 * 1000);
            }
            window.onpopstate = function(event) {
                MobileHomepage.closeMatch();
            };
            $('.ii__overlay_close').click(function() {
                MobileHomepage.closeMatch();
            });
        },
        closeMatch: function() {
            $('.page').removeClass('overlay-on');
            $('.ii__overlay__content').empty();
            $('.ii__overlay__content').removeClass('ii__matchopen');
            $('#overlay-fav-star').children(':first').removeClass('fas').addClass('fal');
            $('.ii__overlay__content').removeData('mid');
            $('.ii__sticky_footer').show();
            // remove history overlay+content from DOM
            // see MobileGeneric.initMatchHistory() for more info
            $('.ii__history_close').click(); // close history popup
            $('#main_content > .ii__history').remove();
            $('#main_content > .ii__history_overlay').remove();


            MobileGeneric.sticky_footer_visible = true;
            hash_recompute(false, false);
        },
        order_matches: function(ord) {
            if (ord == MatchesTable.byleague) {
                return;
            }
            if (ord == 'bytime') {
                $('.ii__om_time').addClass('active blue');
                $('.ii__om_league').removeClass('active blue');
            } else {
                $('.ii__om_time').removeClass('active blue');
                $('.ii__om_league').addClass('active blue');
            }
            Generic.showProgressLoader();
            MatchesTable.store_match_ordering(ord);
            MobileHomepage.matchesRefresh(true);
        },
        matchesRefresh: function(reloadall = false, scroll_to = '') {
            // refresh open match
            $('.ii__overlay__content.ii__matchopen').each(function(i, e) {
                var mid = $('.ii__overlay__content').data('mid');
                var targetElem = reloadall ? $(e).parent().parent().find('.ii__matchopen') : $(e).find('.ii__live_part');
                MobileMatch.refresh(mid, reloadall, targetElem);
            });

            var old_scroll = $(document).scrollTop();
            return Ajax.getLive(
                MobileHomepage.date,
                false,
                MatchesTable.byleague,
                (res) => {
                    $('#results').html(res.html);
                    MatchesTable.applyAllFilters();
                    if (scroll_to) {
                        old_scroll = $(scroll_to).offset().top - 70;
                    }
                    $(document).scrollTop(old_scroll);
                    Generic.hideProgressLoader();
                });
        },
        matchesRefreshLoop: function() {
            MobileHomepage.matchesRefresh().finally(function() {
                setTimeout(MobileHomepage.matchesRefreshLoop, 20 * 1000);
            });
        },
        saveOddsCompany: function(odds_company_id, match_id = 0) {
            Generic.showProgressLoader();
            Ajax.savePrefOddsCompany(odds_company_id, () => {
                var scroll_to = false;
                if (match_id > 0) {
                    scroll_to = '#voting' + match_id;
                }
                MobileHomepage.matchesRefresh(true, scroll_to);
                MobileHomepage.setTitleByOddsCompany(odds_company_id);
            });
        },
        setTitleByOddsCompany: function(odds_company_id) {
            var s = '';
            if (odds_company_id > 1) {
                s = 'Αποτελέσματα αγώνων';
            } else {
                s = 'Αποτελέσματα Πάμε Στοίχημα';
            }
            $('#homepage_title h1').html(s);
            $('#homepage_title select select').val(odds_company_id);
        },
        initMatchOverlay: function() {
            $('.ii__matchpage_tab').click(function() {
                if ($('#match-tabs').position().top < 60) {
                    $('.overlay').scrollTop(
                        $('.overlay').scrollTop() + $('#match-tabs').position().top - 60);
                }
                MobileMatch.recordTabClick(this);
            });
        },
        tr_click: function(id) {
            hash_recompute(false, id);
            $('.ii__overlay__content').html(
                '<div style="width:100%; height:100%; text-align:center; display:table; font-size:1.5em; color:#ddd;">\
                    <span style="display:table-cell; vertical-align:middle;" class="fa-2x">\
                        <i class="fas fa-circle-notch fa-spin"></i>\
                    </span>\
                </div>'
            );
            $('#overlay-title').html('');
            $('.page').addClass('overlay-on');
            $('.ii__overlay__content').data('mid', id);
            $('.ii__sticky_footer').hide();
            MobileGeneric.sticky_footer_visible = false;
            Ajax.getMobileMatchPage(false, id, true, function(data) {
                if (data.success != 'ok') {
                    return;
                }
                $('#overlay-fav-star').data('mid', id);
                $('#overlay-title').html(data.title);
                $('.ii__overlay__content').html(data.html);
                $('.ii__overlay__content').addClass('ii__matchopen');
                MobileHomepage.initMatchOverlay();
                MobileGeneric.initMatchHistory(true);
                Generic.init_popovers();
                Generic.updateTimes();
                Vote.init();
                MatchesTable.applyOverlayFav(id);
            });
            // load glomex if not loaded
            if (!MobileHomepage.glomex) {
                Generic.loadScript(
                    'https://player.glomex.com/integration/1/glomex-player.js',
                    () => {
                        MobileHomepage.glomex = true;
                    }
                );
            }
        }
    };
}();
